import Spinner from "@/components/atoms/Spinner/Spinner";
import FiltersActive from "@/components/molecules/FiltersActive/FiltersActive";
import {
  SetToggleType,
  SetToggles,
} from "@/components/organisms/SBCs/SbcSetHeader/SetToggles";
import MobileHeaderBar from "@/components/organisms/SbcSetHeaderBar/MobileHeaderBar";
import { filterIcon } from "@/designSystemIcons";
import GetCardSBC from "@/pages/Sbcs/SbcSetPage/components/GetCardSbc";
import React, { useEffect, useState } from "react";

export interface SbcSetMobileViewProps {
  sbcSet: any;
  setHeader: React.ReactNode;
  solvedCount: number;
  sbcsCount: number;
  user: any;
  showFiltersBar: boolean;
  setShowFiltersBar: (v: boolean) => void;
  sbcs: any[];
  getCardSBC: React.ReactNode;
  sbcFiltersSidebar: React.ReactNode;
  showImporting: boolean;
  setShowImporting: (v: boolean) => void;
  name: string;
  id: string;
  onClickSetToggle: (type: SetToggleType) => void;
}

const SbcSetMobileView: React.FC<SbcSetMobileViewProps> = ({
  sbcSet,
  setHeader,
  showFiltersBar,
  setShowFiltersBar,
  sbcs,
  sbcFiltersSidebar,
  onClickSetToggle,
  name,
}) => {
  const [localSolvedCount, setLocalSolvedCount] = useState(0);

  useEffect(() => {
    if (sbcSet?.solvedCount !== undefined) {
      setLocalSolvedCount(sbcSet.solvedCount);
    }
  }, [sbcSet?.solvedCount]);

  const isCompleted =
    localSolvedCount > 0 && sbcSet?.sbcsCount === localSolvedCount;

  return (
    <div className="flex flex-col w-full bg-panel-new-background">
      <div>
        <MobileHeaderBar
          showFiltersBar={showFiltersBar}
          setShowFiltersBar={setShowFiltersBar}
          name={name}
        />
      </div>

      {showFiltersBar ? (
        <div className="w-full h-full flex-grow overflow-y-auto">
          {sbcFiltersSidebar}
        </div>
      ) : (
        <>
          <div className="px-4 bg-gradient-to-r from-[#1F354B] to-[#172230] min-h-40">
            {sbcSet && setHeader}
          </div>

          <div className="h-14 flex justify-between items-center px-5 bg-panel-background">
            <div
              className="w-8 h-8 text-dark-tertiary"
              onClick={() => setShowFiltersBar(true)}
            >
              {filterIcon}
            </div>
            <button
              className="bg-action-tertiary text-dark-secondary py-0.5 px-2 rounded flex items-center gap-3"
              onClick={(e) => {
                e.stopPropagation();
                onClickSetToggle("completed");
              }}
            >
              Completed
              <span>
                <SetToggles
                  togglesToShow={["completed"]}
                  onClick={onClickSetToggle}
                  isCompleted={isCompleted}
                  {...sbcSet}
                />
              </span>
            </button>
          </div>

          <div className="h-16 flex items-center">
            <FiltersActive renderHorizontally />
          </div>

          <div className="flex justify-center">
            <div className="w-full">
              {sbcs?.length > 0 ? (
                <>
                  {sbcs.map((sbc, index) => (
                    <GetCardSBC key={sbc.id} sbc={sbc} index={index} />
                  ))}
                </>
              ) : (
                <div className="m-auto">
                  <Spinner />
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SbcSetMobileView;
